import { useNavigate } from "react-router-dom";

import { getLabel } from "../../../../hooks/use-labels";
import { GetLocationState, GetParam } from "../../../../utils/common-utils";

import HexAuthWrapper from "../../../../components/HexAuthWrapper";
import OrderDetailSummary from "./OrderDetailSummary";
import MasterOrderSummary from "./MasterOrderSummary";
import OrderSideDetail from "./OrderSideDetail";
import { OrderDetailSkeleton } from "../OrdersList/OrderSkeletons";
import { useOrderDetail } from "../../../../features/orders/useOrderDetail";
import SummaryFooter from "./OrderDetailSummary/SummaryFooterButtons";
import { errorCopy } from "../OrdersList/order-list-utils";

import "../style.css";

const OrderDetail = () => {
  const navigate = useNavigate();

  const rawId = GetParam("id");
  const orderId = Number(rawId);
  const validId = rawId && Number.isFinite(orderId);

  const { link } = GetLocationState() || { link: "" };

  const {
    detail,
    isMaster,
    master,
    masterRef,
    sections,
    aggregate,
    cancellableIds,
    isLoading,
    errorKind,
    refetch,
  } = useOrderDetail(validId ? orderId : undefined);

  const goBack = () => {
    if (!link) return navigate("/my-orders");

    navigate(link.path, {
      ...(link.previousState && { state: link.previousState }),
    });
  };

  const failure = !validId ? "network" : errorKind;

  return (
    <HexAuthWrapper>
      <div className="ord-screen full-bleed">
        <header className="ord-pagehead">
          <h1 className="ord-pagetitle">{getLabel("orderDetailsLabel")}</h1>

          <button type="button" className="ord-back" onClick={goBack}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M15 5l-7 7 7 7" />
            </svg>

            {getLabel("backToOrdersLabel")}
          </button>
        </header>

        {failure ? (
          <div className="ord-empty">
            <img
              src="/assets/icons/order/empty-order-placeholder.svg"
              alt=""
              aria-hidden="true"
            />

            <h2>{errorCopy[failure].heading}</h2>
            <p>{errorCopy[failure].body}</p>

            {validId && (
              <div className="ord-empty-actions">
                <button type="button" className="ord-btn" onClick={refetch}>
                  Try again
                </button>
              </div>
            )}
          </div>
        ) : isLoading || !detail ? (
          <OrderDetailSkeleton />
        ) : (
          <div className="ord-detail-grid">
            <div className="ord-main">
              {isMaster ? (
                <MasterOrderSummary
                  master={master}
                  masterRef={masterRef}
                  sections={sections}
                  aggregate={aggregate}
                  refetch={refetch}
                />
              ) : (
                <OrderDetailSummary
                  detail={detail}
                  cancellableIds={cancellableIds}
                  refetch={refetch}
                />
              )}
            </div>

            <OrderSideDetail
              detail={detail}
              isMaster={isMaster}
              aggregate={aggregate}
              masterTotal={master?.paidAmount || master?.total}
              refetch={refetch}
              actions={
                isMaster ? (
                  <SummaryFooter
                    cancellableIds={cancellableIds}
                    statusGroup={detail.statusGroup}
                    orderId={detail.id}
                    refetch={refetch}
                  />
                ) : null
              }
            />
          </div>
        )}
      </div>
    </HexAuthWrapper>
  );
};

export default OrderDetail;
